import React, { useEffect, useRef, useState } from 'react';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';

const DragIndicator = () => {
  const [animateLeft, setAnimateLeft] = useState(false);
  const [animateRight, setAnimateRight] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;

    const runAnimationCycle = () => {
      if (!mounted.current) return;
      setAnimateLeft(true);
      setTimeout(() => {
        if (!mounted.current) return;
        setAnimateLeft(false);
        setTimeout(() => {
          if (!mounted.current) return;
          setAnimateRight(true);
          setTimeout(() => {
            if (!mounted.current) return;
            setAnimateRight(false);
          }, 800);
        }, 500);
      }, 800);
    };

    const initialTimeout = setTimeout(runAnimationCycle, 1000);
    const intervalId = setInterval(runAnimationCycle, 5000);

    return () => {
      mounted.current = false;
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="-mt-2 flex items-center justify-center md:hidden">
      <div
        className={`transform transition-all duration-700 ${
          animateLeft ? '-translate-x-1' : 'translate-x-0'
        }`}
      >
        <HiOutlineArrowNarrowLeft
          className={`text-2xl transition-colors duration-300 ${
            animateLeft ? 'text-blue-400' : 'text-blue-500'
          }`}
        />
      </div>
      <span className="mx-3 text-sm font-medium uppercase text-blue-500">Swipe To View</span>
      <div
        className={`transform transition-all duration-700 ${
          animateRight ? 'translate-x-1' : 'translate-x-0'
        }`}
      >
        <HiOutlineArrowNarrowRight
          className={`text-2xl transition-colors duration-300 ${
            animateRight ? 'text-blue-400' : 'text-blue-500'
          }`}
        />
      </div>
    </div>
  );
};

export default DragIndicator;
